<section class="content-header" style="padding: 0.5% !important;">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-md-6">
                <ol class="breadcrumb float-sm-left">
                    <li class="breadcrumb-item">
                        <a [routerLink]="['/admin']"><i class="fas fa-home"></i> &nbsp;Trang chủ</a>
                    </li>
                    <li class="breadcrumb-item active">Danh sách hạn chế</li>
                </ol>
            </div>
            <div class="col-md-6">
                <button class="btn btn-success btn-sm" (click)="open(ThemModal, 'xl', 'Add', '')" (click)="onReset()"
                    style="float: right;">
                    <i class="fas fa-plus-circle"></i> Thêm mới
                </button>
              
            </div>
        </div>
    </div>
</section>
<section class="content cus-body">
    <div class="card">
      <div class="card-body">
        <form class="form-horizontal" [formGroup]="Filter">
          <div class="row">
            <div class="col-md-3 ">
              <label>Mã sinh viên</label>
              <input type="text" class="form-control"  formControlName="Ma_sv_filter"
                (keyup)="filterById()" placeholder="Tìm kiếm mã sinh viên ...">
            </div>
            <div class="col-md-3">
              <label>Họ tên</label>
              <input type="text" class="form-control"  formControlName="Ho_ten_filter"
                (keyup)="filterById()" placeholder="Tìm kiếm theo họ tên..">
            </div>
            </div>
        </form>
      </div>
    </div>
  </section>

<section class="content cus-body">
    <div class="card">
        <div class="card-body">
            <div class="tab-content">
                <div class="active tab-pane">
                    <div class="row">
                        <div class="table-responsive dataTables_wrapper container-fluid dt-bootstrap4 cus-fs">
                            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
                                class="table-bordered dataTables_wrapper no-footer">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let p of dataTable">
                                        <td>{{ p.Ma_sv }}</td>
                                        <td>{{ p.Ho_ten }}</td>
                                        <td>{{ p.Ngay_sinh|date:'dd/MM/yyyy' }}</td>
                                        <td>{{ p.Que_quan }}</td>
                                        <td>{{ p.Ghi_chu }}</td>
                                        <td>
                                            <button class="btn btn-sm btn-danger"
                                                (click)="open(DeleteModal, '', 'Delete', p)" style="margin-right: 7px;">
                                                <i class="fas fa-trash-alt"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<ng-template #ThemModal let-modal>
    <div class="modal-header m-header text-center" style="padding-top: 0px; padding-bottom: 0px;">
        <h4 class="modal-title h-title w-100">Thêm danh sách</h4>
        <span (click)="modal.dismiss('Cross click')" aria-hidden="true" style="font-size: 25px;">&times;</span>
    </div>
    <div class="modal-body">
        <form class="form-horizontal" [formGroup]="Action">
            <div class="row">
                <div class="col-md-4">
                    <label class="col-md-10">Mã sinh viên hoặc CMND</label>
                    <input class="form-control" placeholder="Nhập mã sinh viên hoặc CMND" type="text"
                        formControlName="code" />
                </div>
                <div class="float-sm-left" style="padding: 30px;">
                    <button type="button" class="btn btn-md btn-success" (click)="search()" style="margin-left: 1em;">
                        <i class="fas fa-search"></i> Tìm sinh viên
                    </button>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <label class="col-md-10">Họ tên</label>
                    <input class="form-control" placeholder="Họ tên" type="text" formControlName="Ho_ten" readonly />
                </div>
                <div class="col-md-4">
                    <label class="col-md-10">Ngày sinh</label>
                    <input class="form-control" placeholder="Ngày sinh" type="text" formControlName="Ngay_sinh"
                        readonly />
                </div>
                <div class="col-md-4">
                    <label class="col-md-10">Quê quán</label>
                    <input class="form-control" placeholder="Quê quán" type="text" formControlName="Que_quan"
                        readonly />
                </div>
                <div class="col-md-12">
                    <label class="col-md-10">Ghi chú</label>
                    <textarea class="form-control" cols="100" rows="3" placeholder="Ghi chú"
                        formControlName="Ghi_chu"></textarea>
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <div class="float-right">

            <button type="button" class="btn btn-md btn-success" (click)="onSubmit()">
                <i class="fa-plus-circle fas"></i> Lưu
            </button>
            <button type="button" class="btn btn-md btn-danger" (click)="modal.dismiss('Cross click')"
                style="margin-left: 1em;">
                <i class="far fa-times-circle"></i> Đóng
            </button>
        </div>
    </div>
</ng-template>
<ng-template #DeleteModal let-modal>
    <div class="modal-content">
        <div class="modal-body">
            <div class="icon-box">
                <i class="fas fa-trash-alt" style="
              color: #f15e5e;
              font-size: 46px;
              display: inline-block;
              margin-top: 13px;
            "></i>
            </div>
            <p style="
            color: inherit;
            text-decoration: none;
            font-size: 20px;
            text-align: center;
            font-weight: 600;
            margin-top: 3em;
          ">
                Bạn có chắc chắn muốn xóa
            </p>
            <div class="text-center">
                <button type="button" class="btn btn-md btn-success" (click)="Delete()">
                    Đồng ý
                </button>
                <button type="button" class="btn btn-md btn-danger" (click)="modal.dismiss('Cross click')"
                    style="margin-left: 1em;">
                    Hủy bỏ
                </button>

            </div>
        </div>
    </div>
</ng-template>